/**
 * Header 5 — Featured pill: transparent full-width row; optional sticky (below H4) + menu offset
 */

export const HEADER_6_CONSTANTS = {
  HEADER_FIELDS_CONFIG: [
    {
      fieldName: "featured_pill_show",
      label: "Show featured pill",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
    {
      fieldName: "featured_pill_text",
      label: "Featured pill text",
      value: "Limited Seats Available",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Admissions are open for the Jan 2025 Session…",
      defaultValue: "Limited Seats Available",
    },
    {
      fieldName: "featured_pill_bg_color",
      label: "Featured pill — inner background",
      value: "#DB5803",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#DB5803",
    },
    {
      fieldName: "featured_pill_border_color",
      label: "Featured pill — outer border",
      value: "#DB5803",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#DB5803",
    },
    {
      fieldName: "featured_pill_text_color",
      label: "Featured pill — text",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "featured_pill_sticky",
      label: "Stay visible on scroll (below contact bar, transparent row)",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
    {
      fieldName: "status",
      label: "Status",
      value: true,
      valueType: "boolean",
      filedType: "SWITCH",
      placeholder: "Toggle status",
      required: false,
      defaultValue: true,
    },
  ],
};
